import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useModFed } from 'hooks/useModFed';
import { MODULENAME } from 'module-config';
import { Loader } from '@ggapp/ui';
import { shouldSuppressRemoteLoader } from './utils';

const CommonModule = ({ name }) => {
  const { pathname } = useLocation();
  console.log('CommonModule-------->', name);
  const getImportPath = useCallback(() => {
    console.log('getImportPath-------->', name);
    switch (name) {
      case MODULENAME.AGENTAPP:
        return () => import('agentmanagement/agentmanagementApp');
      case MODULENAME.OEAPP:
        return () => import('onboardingengine/onboardingengineApp');
      case MODULENAME.ANALYTICSAPP:
        return () => import('fsmAnalytics/fsmAnalyticsApp');
      case MODULENAME.CIFAPP:
        return () => import('cifPanel/cifAdminPanel');
      case MODULENAME.HRMSAPP:
        return () => import('hrmsmanagement/hrmsmanagementApp');
      case MODULENAME.CHATBOTAPP:
        return () => import('chatbot/chatbotApp');
      default:
        return null;
    }
  }, [name]);

  const { isRemoteLoading } = useModFed('remoteApp', getImportPath());

  return (
    <>
      <div id="remoteApp" />
      {isRemoteLoading && !shouldSuppressRemoteLoader(pathname) ? (
        <Loader
          size="medium"
          fullScreen
          type="block"
          enableTheming
        />
      ) : null}
    </>
  );
};
CommonModule.propTypes = {
  name: PropTypes.string.isRequired,
};

export default CommonModule;
